/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrderBigTablePageReqVo
 */
export interface OrderBigTablePageReqVo {
    /**
     * 当前页，默认1
     * @type {number}
     * @memberof OrderBigTablePageReqVo
     */
    currentPage?: number;
    /**
     * 每页条数，默认30，最大1000
     * @type {number}
     * @memberof OrderBigTablePageReqVo
     */
    pageSize?: number;
    /**
     * 仓库id
     * @type {number}
     * @memberof OrderBigTablePageReqVo
     */
    warehouseId?: number;
    /**
     * 客户端查询混合运输方式
     * @type {number}
     * @memberof OrderBigTablePageReqVo
     */
    mixedTransportationId?: number;
    /**
     * 服务类型 1 海外直购， 2 橙火入仓服务， 3 3pl
     * @type {number}
     * @memberof OrderBigTablePageReqVo
     */
    requestGroup?: number;
    /**
     * 订单组：1中国订单 2韩国订单 3库存出库订单
     * @type {number}
     * @memberof OrderBigTablePageReqVo
     */
    orderGroup?: number;
    /**
     * 订单状态列表，支持多值（orderStatus=10 或 orderStatus=10,11 或 orderStatus=10&orderStatus=11）
     * @type {Array<number>}
     * @memberof OrderBigTablePageReqVo
     */
    orderStatus?: Array<number>;
    /**
     * 申请类别
     * @type {number}
     * @memberof OrderBigTablePageReqVo
     */
    requestType?: number;
    /**
     * 国际运输方式id
     * @type {number}
     * @memberof OrderBigTablePageReqVo
     */
    internationalTransportMethodId?: number;
    /**
     * 出库运单号
     * @type {string}
     * @memberof OrderBigTablePageReqVo
     */
    ivc?: string;
    /**
     * 市场条码
     * @type {string}
     * @memberof OrderBigTablePageReqVo
     */
    marketBarcode?: string;
    /**
     * 唛头号
     * @type {string}
     * @memberof OrderBigTablePageReqVo
     */
    markNo?: string;
    /**
     * 用户编号
     * @type {string}
     * @memberof OrderBigTablePageReqVo
     */
    userCode?: string;
    /**
     * 用户名
     * @type {string}
     * @memberof OrderBigTablePageReqVo
     */
    userAccount?: string;
    /**
     * 订单编号
     * @type {string}
     * @memberof OrderBigTablePageReqVo
     */
    orderCode?: string;
    /**
     * coupang预约id
     * @type {string}
     * @memberof OrderBigTablePageReqVo
     */
    coupangBookingId?: string;
    /**
     * coupang入仓开始时间
     * @type {string}
     * @memberof OrderBigTablePageReqVo
     */
    coupangWarehouseBeginTime?: string;
    /**
     * coupang入仓结束时间
     * @type {string}
     * @memberof OrderBigTablePageReqVo
     */
    coupangWarehouseEndTime?: string;
    /**
     * 账单状态
     * @type {number}
     * @memberof OrderBigTablePageReqVo
     */
    billStatus?: number;
    /**
     * 工作人员姓名
     * @type {string}
     * @memberof OrderBigTablePageReqVo
     */
    workerName?: string;
    /**
     * 通关方式 1 企业 2 个人
     * @type {number}
     * @memberof OrderBigTablePageReqVo
     */
    ctmsType?: number;
    /**
     * 收件人姓名
     * @type {string}
     * @memberof OrderBigTablePageReqVo
     */
    receiverName?: string;
    /**
     * 从韩国仓库入库证编码
     * @type {string}
     * @memberof OrderBigTablePageReqVo
     */
    trunkWarehouseCode?: string;
    /**
     * 从韩国仓库下单时的入库证编码
     * @type {string}
     * @memberof OrderBigTablePageReqVo
     */
    koreaWarehouseCode?: string;
    /**
     * 订单创建时间开始
     * @type {string}
     * @memberof OrderBigTablePageReqVo
     */
    orderCreateBeginTime?: string;
    /**
     * 订单创建时间结束
     * @type {string}
     * @memberof OrderBigTablePageReqVo
     */
    orderCreateEndTime?: string;
    /**
     * 商品编号
     * @type {string}
     * @memberof OrderBigTablePageReqVo
     */
    goodsCode?: string;
    /**
     * 商品SKU编号
     * @type {string}
     * @memberof OrderBigTablePageReqVo
     */
    skuCode?: string;
    /**
     * 中国电商购物平台的订单编号
     * @type {string}
     * @memberof OrderBigTablePageReqVo
     */
    platformOrderCode?: string;
    /**
     * 中国快递运单号
     * @type {string}
     * @memberof OrderBigTablePageReqVo
     */
    trackNo?: string;
    /**
     * 是否只查询存在商品未输入快递单号的订单（中国、韩国均适用）：1 是，0/空 否
     * @type {number}
     * @memberof OrderBigTablePageReqVo
     */
    withoutTrackNo?: number;
    /**
     * 订单id列表 给出库计划查询用的
     * @type {Array<number>}
     * @memberof OrderBigTablePageReqVo
     */
    orderIds?: Array<number>;
    /**
     * 用户id
     * @type {number}
     * @memberof OrderBigTablePageReqVo
     */
    userId?: number;
    /**
     * 提货方式 1 返送 2 自提
     * @type {number}
     * @memberof OrderBigTablePageReqVo
     */
    takeGoodsMethod?: number;
    /**
     * 是否是首次订单 1 是 0 否
     * @type {number}
     * @memberof OrderBigTablePageReqVo
     */
    firstOrder?: number;
    /**
     * 预计出库时间
     * @type {string}
     * @memberof OrderBigTablePageReqVo
     */
    expectedOutboundDate?: string;
}

/**
 * Check if a given object implements the OrderBigTablePageReqVo interface.
 */
export function instanceOfOrderBigTablePageReqVo(value: object): value is OrderBigTablePageReqVo {
    return true;
}

export function OrderBigTablePageReqVoFromJSON(json: any): OrderBigTablePageReqVo {
    return OrderBigTablePageReqVoFromJSONTyped(json, false);
}

export function OrderBigTablePageReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderBigTablePageReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'currentPage': json['currentPage'] == null ? undefined : json['currentPage'],
        'pageSize': json['pageSize'] == null ? undefined : json['pageSize'],
        'warehouseId': json['warehouseId'] == null ? undefined : json['warehouseId'],
        'mixedTransportationId': json['mixedTransportationId'] == null ? undefined : json['mixedTransportationId'],
        'requestGroup': json['requestGroup'] == null ? undefined : json['requestGroup'],
        'orderGroup': json['orderGroup'] == null ? undefined : json['orderGroup'],
        'orderStatus': json['orderStatus'] == null ? undefined : json['orderStatus'],
        'requestType': json['requestType'] == null ? undefined : json['requestType'],
        'internationalTransportMethodId': json['internationalTransportMethodId'] == null ? undefined : json['internationalTransportMethodId'],
        'ivc': json['ivc'] == null ? undefined : json['ivc'],
        'marketBarcode': json['marketBarcode'] == null ? undefined : json['marketBarcode'],
        'markNo': json['markNo'] == null ? undefined : json['markNo'],
        'userCode': json['userCode'] == null ? undefined : json['userCode'],
        'userAccount': json['userAccount'] == null ? undefined : json['userAccount'],
        'orderCode': json['orderCode'] == null ? undefined : json['orderCode'],
        'coupangBookingId': json['coupangBookingId'] == null ? undefined : json['coupangBookingId'],
        'coupangWarehouseBeginTime': json['coupangWarehouseBeginTime'] == null ? undefined : json['coupangWarehouseBeginTime'],
        'coupangWarehouseEndTime': json['coupangWarehouseEndTime'] == null ? undefined : json['coupangWarehouseEndTime'],
        'billStatus': json['billStatus'] == null ? undefined : json['billStatus'],
        'workerName': json['workerName'] == null ? undefined : json['workerName'],
        'ctmsType': json['ctmsType'] == null ? undefined : json['ctmsType'],
        'receiverName': json['receiverName'] == null ? undefined : json['receiverName'],
        'trunkWarehouseCode': json['trunkWarehouseCode'] == null ? undefined : json['trunkWarehouseCode'],
        'koreaWarehouseCode': json['koreaWarehouseCode'] == null ? undefined : json['koreaWarehouseCode'],
        'orderCreateBeginTime': json['orderCreateBeginTime'] == null ? undefined : json['orderCreateBeginTime'],
        'orderCreateEndTime': json['orderCreateEndTime'] == null ? undefined : json['orderCreateEndTime'],
        'goodsCode': json['goodsCode'] == null ? undefined : json['goodsCode'],
        'skuCode': json['skuCode'] == null ? undefined : json['skuCode'],
        'platformOrderCode': json['platformOrderCode'] == null ? undefined : json['platformOrderCode'],
        'trackNo': json['trackNo'] == null ? undefined : json['trackNo'],
        'withoutTrackNo': json['withoutTrackNo'] == null ? undefined : json['withoutTrackNo'],
        'orderIds': json['orderIds'] == null ? undefined : json['orderIds'],
        'userId': json['userId'] == null ? undefined : json['userId'],
        'takeGoodsMethod': json['takeGoodsMethod'] == null ? undefined : json['takeGoodsMethod'],
        'firstOrder': json['firstOrder'] == null ? undefined : json['firstOrder'],
        'expectedOutboundDate': json['expectedOutboundDate'] == null ? undefined : json['expectedOutboundDate'],
    };
}

export function OrderBigTablePageReqVoToJSON(json: any): OrderBigTablePageReqVo {
    return OrderBigTablePageReqVoToJSONTyped(json, false);
}

export function OrderBigTablePageReqVoToJSONTyped(value?: OrderBigTablePageReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'currentPage': value['currentPage'],
        'pageSize': value['pageSize'],
        'warehouseId': value['warehouseId'],
        'mixedTransportationId': value['mixedTransportationId'],
        'requestGroup': value['requestGroup'],
        'orderGroup': value['orderGroup'],
        'orderStatus': value['orderStatus'],
        'requestType': value['requestType'],
        'internationalTransportMethodId': value['internationalTransportMethodId'],
        'ivc': value['ivc'],
        'marketBarcode': value['marketBarcode'],
        'markNo': value['markNo'],
        'userCode': value['userCode'],
        'userAccount': value['userAccount'],
        'orderCode': value['orderCode'],
        'coupangBookingId': value['coupangBookingId'],
        'coupangWarehouseBeginTime': value['coupangWarehouseBeginTime'],
        'coupangWarehouseEndTime': value['coupangWarehouseEndTime'],
        'billStatus': value['billStatus'],
        'workerName': value['workerName'],
        'ctmsType': value['ctmsType'],
        'receiverName': value['receiverName'],
        'trunkWarehouseCode': value['trunkWarehouseCode'],
        'koreaWarehouseCode': value['koreaWarehouseCode'],
        'orderCreateBeginTime': value['orderCreateBeginTime'],
        'orderCreateEndTime': value['orderCreateEndTime'],
        'goodsCode': value['goodsCode'],
        'skuCode': value['skuCode'],
        'platformOrderCode': value['platformOrderCode'],
        'trackNo': value['trackNo'],
        'withoutTrackNo': value['withoutTrackNo'],
        'orderIds': value['orderIds'],
        'userId': value['userId'],
        'takeGoodsMethod': value['takeGoodsMethod'],
        'firstOrder': value['firstOrder'],
        'expectedOutboundDate': value['expectedOutboundDate'],
    };
}

